<form (ngSubmit)="addComment(commentForm.valid)" #commentForm="ngForm">
  <h2 class="mb-0" mat-dialog-title>{{"ADD_COMMENT.ADD_COMMENT"|translate}}</h2>
  <hr />

  <mat-dialog-content>
    <div class="my-comment">
      <h6 class="mb-0">{{"ADD_COMMENT.GIVE_RATING"|translate}}</h6>
      <div class="position-relative mb-3">
        <star-rating
          value="0"
          totalstars="{{ totalstar }}"
          checkedcolor="red"
          uncheckedcolor="black"
          size="24px"
          readonly="false"
          (rate)="onRate($event)"
          type="number"
        ></star-rating>

        <div
          style="color: red;"
          class="validation_div"
          *ngIf="commentForm.submitted && !model.rating"
        >
          <p class="mb-0">{{"ADD_COMMENT.RATING_REQUIRES"|translate}}</p>
        </div>
      </div>
      <h6 class="mb-0">{{"ADD_COMMENT.LEAVE_YOUR_COMMENT"|translate}}</h6>
      <div class="position-relative pt-2 w-100">
        <textarea
          name="comment"
          [(ngModel)]="model.review"
          placeholder="{{'ADD_COMMENT.PLACEHOLDER_ADD_COMMENT'|translate}}"
          class="form-control"
          #review="ngModel"
          required
          maxlength="255"
        ></textarea>
        <div
          style="color: red;"
          class="validation_div"
          *ngIf="review.errors && (review.dirty || commentForm.submitted)"
        >
          <p class="mb-0" *ngIf="review.errors.required">
            {{"ADD_COMMENT.COMMENT_REQUIRED"|translate}}
          </p>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <hr />
  <mat-dialog-actions class="justify-content-end">
    <button
      style="color: #fff !important;"
      class="btn btn-danger mr-2"
      mat-dialog-close
    >
      {{"ADD_COMMENT.CANCEL"|translate}}
    </button>
    <button
      style="color: #fff !important;"
      [disabled]="disabledStatus"
      class="btn btn-theme"
    >
      <span class="spin" [ngClass]="{'icon-loader':disabledStatus}"> </span>
      {{"ADD_COMMENT.SUBMIT"|translate}}
    </button>
  </mat-dialog-actions>
</form>
